import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505] text-white grid-noise">
      <header className="border-b border-[#2A2A2A]">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/"><img src={LOGO_URL} alt="Splash Creative Hub" className="w-[140px] h-auto object-contain" /></Link>
          <Link data-testid="privacy-home-link" to="/" className="text-sm text-[#A1A1AA] hover:text-white inline-flex items-center gap-2 transition-colors"><ArrowLeft className="w-4 h-4" /> Back to home</Link>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 lg:px-10 py-16" data-testid="privacy-page">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#FF4D00] mb-5"><ShieldCheck className="w-4 h-4" /> Privacy & Security</div>
        <h1 className="font-bebas text-6xl sm:text-7xl leading-[0.9] tracking-tight mb-8">DATA PROTECTION<br /><span className="text-[#FF4D00]">& PRIVACY</span></h1>

        <div className="border border-[#FF4D00]/40 bg-[#FF4D00]/[0.06] p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.2em] text-[#FF4D00] mb-2">Security Commitment</div>
          <p className="text-base text-[#D4D4D8] leading-relaxed">Your privacy is our priority. All sensitive documents, including W9s and resumes, are encrypted at rest and in transit. Access is strictly limited to authorized administrators for payroll and compliance purposes only.</p>
        </div>

        <div className="space-y-4 text-sm text-[#A1A1AA] leading-relaxed max-w-2xl">
          <p>Our full data protection policy will be published here soon. If you have any questions about how your information is handled in the meantime, please reach out to our team.</p>
        </div>
      </main>

      <footer className="border-t border-[#2A2A2A] mt-8">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-8 flex items-center justify-between text-xs text-[#A1A1AA]">
          <span className="font-bebas text-lg text-white tracking-wide">SPLASH CREATIVE HUB</span>
          <span>© 2026 Splash Creative Hub. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
